import React, { useEffect, useRef, useState } from 'react';
import { Typography, Accordion, AccordionSummary, Chip } from '@mui/material';
import { DropdownArrow } from '../assets/icons/Icons';
import 'react-toastify/dist/ReactToastify.css';

function CustomAccordion({
	id,
	mainTitle,
	expanded,
	handleExpansion,
	children,
	showTag,
}) {
	const accordionRef = useRef(null);

	useEffect(() => {
		if (accordionRef.current) {
			const observer = new ResizeObserver(entries => {
				// eslint-disable-next-line prettier/prettier
				entries.forEach(entry => { });
			});

			observer.observe(accordionRef.current);

			return () => observer.disconnect();
		}
	}, []);

	return (
		<Accordion
			expanded={expanded}
			onChange={handleExpansion}
			ref={accordionRef}
			sx={{
				width: '100%',
				borderRadius: '5px',
				marginTop: '10px',
				'& .MuiAccordionDetails-root': {
					display: 'flex',
					flexDirection: 'column',
				},
			}}>
			<AccordionSummary
				expandIcon={<DropdownArrow />}
				aria-controls={`panel${id}-content`}
				id={`panel${id}-header`}
				sx={{ paddingY: '5px', paddingX: '10px' }}>
				<Typography
					color={'#28696D'}
					fontSize={'16px'}
					marginBottom={'5px'}
					fontWeight={'700'}>
					{mainTitle}
				</Typography>
				{showTag && (
					<Chip
						label={'Modified'}
						size="small"
						sx={{
							marginLeft: '10px',
							color: '#FFFFFF',
							fontWeight: '500',
							backgroundColor: '#ff8424',
						}}
					/>
				)}
			</AccordionSummary>
			{children}
		</Accordion>
	);
}

export default CustomAccordion;
